/* Emarsys Recs helper — prefers doT templates but can lazy‑load doT if missing */
(function(){
  if (window.EMARSYS_RECS) return;

  function byId(id){ return document.getElementById(id); }

  var _queue = [];
  var _waiting = false;
  var MAX_WAIT = 5000;   // ms
  var INTERVAL = 50;     // ms

  var _config = { dotSrc: null };
  var _dotLoading = false;
  var _dotPromise = null;

  function configure(opts){
    if (!opts) return;
    if (opts.dotSrc) _config.dotSrc = opts.dotSrc;
  }

  function _loadScript(src){
    return new Promise(function(resolve, reject){
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function(){ resolve(); };
      s.onerror = function(){ reject(new Error('Failed to load: ' + src)); };
      (document.head || document.documentElement).appendChild(s);
    });
  }

  function _currentScript(){
    // Try currentScript; fallback to last matching <script src*="emarsys-recs.js">
    var cs = document.currentScript;
    if (cs) return cs;
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length - 1; i >= 0; i--) {
      var sc = scripts[i];
      if (sc && sc.src && sc.src.indexOf('emarsys-recs.js') !== -1) return sc;
    }
    return null;
  }

  function _getDotSrc(){
    if (_config.dotSrc) return _config.dotSrc;
    var host = _currentScript();
    if (host) {
      var attr = host.getAttribute('data-dot-src');
      if (attr) return attr;
    }
    return null;
  }

  function _ensureDoT(){
    if (window.doT) return Promise.resolve();
    if (_dotLoading && _dotPromise) return _dotPromise;

    var src = _getDotSrc();
    if (!src) {
      return Promise.reject(new Error('[EMARSYS_RECS] doT.js missing and no data-dot-src or configure({dotSrc}) provided'));
    }

    _dotLoading = true;
    _dotPromise = _loadScript(src).then(function(){
      _dotLoading = false;
    }).catch(function(e){
      _dotLoading = false;
      throw e;
    });
    return _dotPromise;
  }

  function _flushQueue(){
    var item;
    while ((item = _queue.shift())) {
      try { _render(item); }
      catch(e){ console.error('[EMARSYS_RECS.render] Queued render failed:', e); }
    }
  }

  function _waitForDoT(){
    if (_waiting) return;
    _waiting = true;

    // Kick off lazy load once per wait cycle
    _ensureDoT().then(function(){
      _waiting = false;
      _flushQueue();
    }).catch(function(err){
      // Fall back to polling for 5s in case another loader brings doT later
      var deadline = Date.now() + MAX_WAIT;
      (function poll(){
        if (window.doT){
          _waiting = false;
          _flushQueue();
          return;
        }
        if (Date.now() >= deadline){
          _waiting = false;
          console.error('[EMARSYS_RECS] doT.js not available after ' + MAX_WAIT + 'ms. Skipping ' + _queue.length + ' queued render(s).', err && err.message ? err.message : err);
          _queue.length = 0;
          return;
        }
        setTimeout(poll, INTERVAL);
      })();
    });
  }

  function _render(opts){
    var tplEl = byId(opts.templateId);
    var container = byId(opts.containerId);

    if (!tplEl){
      console.error('[EMARSYS_RECS.render] Template element not found:', opts.templateId);
      return;
    }
    if (!container){
      console.error('[EMARSYS_RECS.render] Container element not found:', opts.containerId);
      return;
    }

    var templateText = tplEl.textContent || tplEl.innerText || tplEl.text || '';
    if (!templateText){
      console.error('[EMARSYS_RECS.render] Template text is empty');
      return;
    }

    if (!window.doT){
      // Not ready: queue & ensure doT
      _queue.push(opts);
      _waitForDoT();
      return;
    }

    var tpl;
    try {
      tpl = window.doT.template(templateText);
    } catch(e){
      console.error('[EMARSYS_RECS.render] Failed to create template function:', e);
      return;
    }

    var context = {
      products: Array.isArray(opts.products) ? opts.products : [],
      priceFmt: opts.priceFmt || function(v){ try { return (Number(v) || 0).toFixed(2); } catch(_){ return v; } }
    };

    try {
      var html = tpl(context);
      container.innerHTML = html;
      requestAnimationFrame(function () {
        try {
          var sc = container.closest && container.closest('swiper-component');
          if (sc && typeof sc.refreshSlides === 'function') sc.refreshSlides();
        } catch (e2) {}
      });
    } catch (e){
      console.error('[EMARSYS_RECS.render] Template execution error:', e);
    }
  }

  function render(opts){
    if (!opts || !opts.templateId || !opts.containerId){
      console.error('[EMARSYS_RECS.render] Missing required options: templateId, containerId');
      return;
    }
    if (!window.doT){
      _queue.push(opts);
      _waitForDoT();
      return;
    }
    _render(opts);
  }

  window.EMARSYS_RECS = { render: render, configure: configure };
})();